import React from 'react'
import type { ContextUploadItem } from '~/types/contextUpload'
import { UploadCard } from './UploadCard'

export interface UploadCardsContainerProps {
  uploads: ContextUploadItem[]
  onRemove: (id: number) => void
}

/**
 * Horizontal scrollable container for upload cards
 * Shows all pending/uploading/completed context uploads
 */
export const UploadCardsContainer: React.FC<UploadCardsContainerProps> = ({
  uploads,
  onRemove
}) => {
  if (uploads.length === 0) return null

  return (
    <div
      className='flex overflow-x-auto scrollbar-thin scrollbar-thumb-tokens-neutral-bg-grey-3 scrollbar-track-transparent'
      style={{
        gap: '8px',
        paddingBottom: '4px', // Space for scrollbar
        marginBottom: '-4px' // Compensate for padding
      }}
    >
      {uploads.map(upload => (
        <div key={upload.id} className='flex-shrink-0'>
          <UploadCard upload={upload} onRemove={onRemove} />
        </div>
      ))}
    </div>
  )
}

export default UploadCardsContainer
